import { spacing as space } from "../tokens/semantic";

export const spacing = (...args) => {
  const mapArg = (arg) => {
    /* Test if string aligns with any token key. */
    if (typeof arg === 'string' && space[arg]) return space[arg];
    /* 
    Fallback to remap MUI numbers to rem values.
    */
    if (typeof arg === 'number') return `${arg * 0.25}rem`; 
    /*
    Fallback for other string values.
    */
    return String(arg);
  };
  return args.map(mapArg).join(' ');
};

export default spacing;
